import React from 'react'
import { timeDateFormat } from '../../../modules/Utils'
import moment from 'moment'

const DateTimeCell = ({ value }) => value && timeDateFormat(moment(value))
export default DateTimeCell
